<span class="stepper-actions" [formGroup]="formGroup">
	<span class="container-icon" (click)="decreaseAmount()">
		<app-icon class="icon remove" [iconName]="iconDecrement" />
	</span>

	<app-input
		numberOnly
		id="quantity"
		type="text"
		class="quantity-input"
		formControlName="quantity"
		controlId="quantity"
		[control]="formGroup.get('quantity')"
		[label]="translations['quantity']"
		[placeholder]="translations['quantity']"
		[min]="min"
		(ngModelChange)="changeAmount()"
	/>

	<span class="container-icon" (click)="increaseAmount()">
		<app-icon class="icon add" [iconName]="iconIncrement" />
	</span>
</span>
